import type { ReactNode } from 'react';
import { CookieBanner, FloatingContactsFab } from '../../components';
import LeadFormModal from '../../pages/LeadFormModal';
import { useLeadModal } from '../../contexts/LeadModalContext';
import Header from './components/Header';
import Footer from './components/Footer';
import './Layout.scss';

export interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { open, serviceSlug, closeModal } = useLeadModal();

  return (
    <div className="layout">
      <Header />
      <main className="layout__main">{children}</main>
      <Footer />
      <FloatingContactsFab
        telegram="https://t.me/mrbek112"
        whatsapp="https://wa.me/998900770302"
        phone="tel:+998900770302"
      />
      <CookieBanner />
      <LeadFormModal open={open} onClose={closeModal} defaultServiceSlug={serviceSlug} />
    </div>
  );
}
